import * as React from 'react';
import {Box, Stack} from "../../../../shared/layouts";
import Button from "../../../../shared/Button";
import {useTranslation} from "react-i18next";
import {QueryResult} from 'react-query/types/core/types';
import {useQuery} from "react-query";
import axios from "axios";
import {useParams} from "react-router-dom";
import Card from '../../../../shared/Card';
import {useMediaQuery} from '@dnhb/node_package';
import {useTheme} from '@emotion/react';

const STATUS_CHECK_INTERVAL = 2; //seconds

const FinlyIFrameForm = ({queryResult}: { queryResult: QueryResult<any, any> }) => {
    const {t} = useTranslation();
    const {finlyFormId} = useParams();
    const {breakpoints} = useTheme();

    const isMinDesktop = useMediaQuery(
        `(min-width: ${breakpoints.ml ?? '56.25rem'})`
    );

    const {
        refetch,
        data: {completed_at, finly_form_url, show_iframe} = {},
    } = queryResult;

    useQuery(
        ['FinlyFormCompleted', finlyFormId],
        async () => {
            const {data} = await axios.get(`/finly-form/${finlyFormId}/status`);
            if (data.completed) {
                await refetch();
            }

            return data;
        },
        {
            enabled: !!finlyFormId && !completed_at,
            refetchOnWindowFocus: false,
            refetchInterval: STATUS_CHECK_INTERVAL * 1000,
        }
    );


    return (
        <Card>
            <Stack space={isMinDesktop ? 'm' : 's'}>
                <Box css={{position: 'relative'}}>
                    {show_iframe && (
                        <iframe
                            src={finly_form_url}
                            height="100%"
                            width="100%"
                            css={{
                                // 72 = Mobile header height
                                height: 'calc(100vh - 72px)',
                                width: '100%',
                                border: 0
                            }}
                        />
                    ) || (
                        <Button
                            onClick={() => window.open(finly_form_url)}
                        >
                            {t('Formulier invullen')}
                        </Button>
                    )}
                </Box>
            </Stack>
        </Card>
    );
}
export default FinlyIFrameForm;
